import Actions from '../../odata/actions';

const actions = new Actions('documentLink', 'documentLinks');

export default actions;
